<template>
  <div class="Inside_line_detail" :style="screenHeight">
    <div class="fixed_search">
      <div class="date_selected fixed_search_input">
        <el-date-picker :clearable="false" v-model="starEndTime" unlink-panels type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期" align="left" :default-time="['00:00:00', '23:59:59']"
                        :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_search_input">
        <Input v-model="IVRName" placeholder="请输入IVR名称" title="IVR名称"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="IVRKeyCode" placeholder="请输入IVR按键" title="IVR按键"/>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
        <Button type="info" class="operation_btn" style="margin-left: 10px" @click="exportExcel('8_3-6-1','统计报表=>IVR通话统计=>导出')" v-if="roleList['8_3-6-1']">导出</Button>
      </div>
      <div class="fixed_operation_btn"  style="margin-top:-3px;">
      <Tooltip class="tips_font" placement="right">
                    <div slot="content">
                      <p>名称：IVR名称</p>
                      <p>IVR按键：客户进入IVR后进入按键采集节点所点击的按键信息</p>
                      <p>按键描述：IVR配置中的按键采集描述信息</p>
                      <p>IVR层级：客户在IVR进入的按键采集节点的级数</p>
                      <p>次数：客户进入该按键采集节点的次数</p>
                    </div>
                   <img src="../../../assets/image/homeAsk.png"/>
      </Tooltip>
      </div>
    </div>
    <div class="fixed_table">
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" stripe ref="selection"  @selection-change="getSelectedId">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
        <el-table-column  fixed="right" label="次数" width="150" align="center">
          <template slot-scope="scope">
            <el-button @click="searchIVRCount(scope.row)" type="text" size="small">{{scope.row.count}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <IVRCountPop @closeIVRCount="closeIVRCount" :showIVRCount="showIVRCount"  :ivrTotal="ivrTotal" :starEndTime="starEndTime"></IVRCountPop>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
  import IVRCountPop from '@/components/statisticsReportForm/CallStatistics/IVRCountPop.vue'
  export default {
    name: "IVRTotal",
    mixins:[publicFunClass,customerPublicBtn],
    props:{
      pageCode:String
    },
    components:{
      IVRCountPop
    },
    data(){
      return {
        showPageCount:0,
        roleList:JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        screenHeight:{height:''},
        tableHeight:600,
        total:0,
        pageSizeList:[10,20,30,40,50,100,200],
        currentPage:1,
        pageSize:20,
        speedChangePage: 1,
        spinShow:false,
        showIVRCount:false,
        editable:false,
        checkedAll:false,
        fieldList: [
          {type: 'selection', width: 50, fixed: true}, {key:'ivrname','title':'IVR名称'},{key:'ivrKey','title':'IVR按键'},{key:'smsButtonDesc','title':'按键描述'}, {key:'ivrLevel','title':'IVR层级'}
        ],
        contentList: [],
        checkIds:[],
        starEndTime:[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')],
        IVRName:'',
        IVRKeyCode:'',
        IVRDescr:'',
        journalType:"null",
        menuId:"null",
        ivrTotal:{},
        queryParam: null,
      }
    },
    methods:{
      searchIVRCount:function(row){
        this.showIVRCount=true;
        this.ivrTotal=row;
      },
      closeIVRCount:function(phone){
        this.showIVRCount=false;
        if(phone){
          this.messageOrPhone(phone);
        }
      },
      initSearch:function () {
        this.spinShow=true;
        this.$emit("closeVn",true);
        let that=this;
        let param={
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          date:this.starEndTime.length==0?"":this.starEndTime.toString(),
          IVRName:this.IVRName,
          IVRKeyCode:this.IVRKeyCode,
          IVRDescr:this.IVRDescr,
          journalType:"统计报表=>通话统计=>IVR统计查询",
          menuId:"null"
        };
        // 导出时按照查询条件导出
        this.queryParam = param;
        this.$http.post("callIvrButton/toIndex.json",param) .then(function (res) {
          let result=res.data;
          that.spinShow=false;
          if(result.flag!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.checkIds=[];
          that.contentList=res.data.obj.list.content;
          that.total=res.data.obj.list.totalSize;
        })
      },
      reset:function(){
        this.starEndTime=[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')];
        this.IVRName="";
        this.IVRKeyCode="";
        this.IVRDescr="";
      },
      closePublicPop:function (popSign) {
          if(!this.queryParam){
          this.$Modal.info({
              title:'提示',
              content:'请点击查询后再导出'
            });
          return false;
        }
        if(!this.contentList || this.contentList.length <= 0){
          this.$Modal.info({
              title:'提示',
              content:'当前无可导出的数据'
            });
          return false;
        }
        delete this.queryParam["pageNum"];
        delete this.queryParam["pageSize"];

        this.$set(this.queryParam, 'type', '1');
        this.$set(this.queryParam, 'journalType', this.journalType+"按搜索结果"+popSign);
        this.$set(this.queryParam, 'menuId', this.menuId);
          this.$Loading.start();
          this.operateExcelExport(this.queryParam,"callIvrButton/exportIntercomCall.json");
      },
      //导出
      exportExcel:function (menuId,journalType) {
        this.journalType=journalType;
        this.menuId=menuId;
        this.closePublicPop('IVR统计导出')
      }
    },
    created(){
      this.screenHeight.height=this.mountHeight(91);
      let clientHeight=document.documentElement.clientHeight;
      this.tableHeight=clientHeight-182;
    },
    destroyed(){
      this.$emit("closeVn",true);
    },
    watch:{
      pageCode:function () {
        if (this.pageCode == '8_3-6' && this.showPageCount == 0) {
          this.$emit("openVn", true);
          this.showPageCount++;
        }
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/CallStatistics/IVRTotal.vue